// @material-ui/icons
import LoginPage from "views/Auth/LoginPage.js";
import RegisterPage from "views/Auth/RegisterPage";
import BannerCreate from "views/Banner/BannerCreate";
import BannerIndex from "views/Banner/BannerIndex";
import BannerView from "views/Banner/BannerView";
import BlacklistCreate from "views/Blacklist/BlacklistCreate";
import BlacklistIndex from "views/Blacklist/BlacklistIndex";
import CollectionIndex from "views/Collection/CollectionIndex";
import DistributeCoinCreate from "views/DistributeCoin/DistributeCoinCreate";
import DistributeCoinIndex from "views/DistributeCoin/DistributeCoinIndex";
import RewardSummary from "views/RewardTier/RewardStat";
import RewardTierIndex from "views/RewardTier/RewardTierIndex";
import UserCreate from "views/User/UserCreate";
import UserIndex from "views/User/UserIndex";
import UserView from "views/User/UserView";
import ForgotPage from "./views/Auth/ForgotPage";
import UserProfile from "./views/Auth/UserProfile";
import CollectionCreate from "./views/Collection/CollectionCreate";
import NftCreate from "./views/Nft/NftCreate";
import NftIndex from "./views/Nft/NftIndex";
import StakingCreateNormal from "./views/Staking/StakingCreateNormal";
import StakingFee from "./views/Staking/StakingFee";
import StakingIndex from "./views/Staking/StakingIndex";

import PuushdotPoolIndex from "./views/PuushdotPool/PuushdotPoolIndex";
import PuushdotPoolView from "./views/PuushdotPool/PuushdotPoolView";
import PuushdotPoolCreate from "./views/PuushdotPool/PuushdotPoolCreate";
import PuushdotPoolActivity from "./views/PuushdotPool/PuushdotPoolActivity";

import RetroPoolView from "views/PuushdotPool/RetroPoolView";
import SwapIndex from "./views/Swap/SwapIndex";
import SwapView from "./views/Swap/SwapView";
//chain
import DiscordTokenCreate from "views/DiscordToken/DiscordTokenCreate";
import DiscordTokenIndex from "views/DiscordToken/DiscordTokenIndex";
import DiscordTokenView from "views/DiscordToken/DiscordTokenView";

import { BarChart, Money } from "@material-ui/icons";
import Group from "@material-ui/icons/Group";
import CollectionsIcon from "@mui/icons-material/Collections";
import DataSaverOnIcon from "@mui/icons-material/DataSaverOn";
import CategoryIcon from "@mui/icons-material/Category";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import NoAccountsIcon from "@mui/icons-material/NoAccounts";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import SettingsIcon from "@mui/icons-material/Settings";
import TollIcon from "@mui/icons-material/Toll";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HubIcon from "@mui/icons-material/Hub";
import ConfigCreate from "views/Config/ConfigCreate";
import ConfigIndex from "views/Config/ConfigIndex";
import StakingFeeSpecial from "./views/Staking/StakingFeeSpecial";
import StakingFeeTest from "views/Staking/StakingFeeTest";
import StakingBoosterEdit from "views/Staking/StakingBoosterEdit";
import StakingAprEdit from "views/Staking/StakingAprEdit";
import QuestIndex from "views/Quest/QuestIndex";
import QuestCreate from "views/Quest/QuestCreate";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import CollectionIndexList from "views/Collection/CollectionIndexList";
import StakingCreateSelectType from "views/Staking/StakingCreateSelectType";
import StakingCreateSoft from "views/Staking/StakingCreateSoft";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PaymentCoinCreate from "views/PaymentCoin/PaymentCoinCreate";
import PaymentCoinIndex from "views/PaymentCoin/PaymentCoinIndex";
import CollectionPayment from "views/Collection/CollectionPayment";
import BridgeView from "views/Bridge/BridgeView";
import BridgeCreate from "views/Bridge/BridgeCreate";
import BridgeIndex from "views/Bridge/BridgeIndex";
import DexCoinCreate from "views/DexCoin/DexCoinCreate";
import DexCoinIndex from "views/DexCoin/DexCoinIndex";

var dashRoutes = [
  {
    hide: true,
    collapse: true,
    name: "Auth",
    views: [
      {
        path: "/login",
        name: "Login",
        component: LoginPage,
        layout: "/auth",
      },
      {
        path: "/register",
        name: "Register",
        component: RegisterPage,
        layout: "/auth",
      },
      {
        path: "/forgot",
        name: "Forgot",
        component: ForgotPage,
        layout: "/auth",
      },
    ],
  },
  // =================================================================== DASHBOARD
  {
    isMenu: true,
    path: "/dashboard",
    name: "NFT",
    component: NftIndex,
    layout: "/admin",
    icon: InsertPhotoIcon,
  },
  {
    path: "/collection/:id",
    name: "CollectionView",
    component: CollectionCreate,
    layout: "/admin",
  },
  {
    path: "/collection-payment/:id",
    name: "CollectionPayment",
    component: CollectionPayment,
    layout: "/admin",
  },
  {
    path: "/collection-edit",
    name: "Create Collection",
    component: CollectionCreate,
    layout: "/admin",
  },
  {
    path: "/collection-index-list",
    name: "Collection Index",
    component: CollectionIndexList,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/collection",
    name: "Collection",
    component: CollectionIndex,
    layout: "/admin",
    icon: CollectionsIcon,
  },
  // =================================================================== BRIDGE
  {
    path: "/bridge/:id",
    name: "BridgeView",
    component: BridgeView,
    layout: "/admin",
  },
  {
    path: "/approve-token/:id",
    name: "Edit Bridge",
    component: BridgeCreate,
    layout: "/admin",
  },
  {
    path: "/approve-token",
    name: "Create Bridge",
    component: BridgeCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/bridge",
    name: "Bridge",
    component: BridgeIndex,
    layout: "/admin",
    icon: HubIcon,
  },
  // =================================================================== BANNERS
  {
    path: "/banner/:id",
    name: "BannerView",
    component: BannerView,
    layout: "/admin",
  },
  {
    path: "/banner-edit/:id",
    name: "Edit Banner",
    component: BannerCreate,
    layout: "/admin",
  },
  {
    path: "/banner-edit",
    name: "Create Banner",
    component: BannerCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/banner",
    name: "Banner",
    component: BannerIndex,
    layout: "/admin",
    icon: ViewCarouselIcon,
  },
  // =================================================================== CHAIN
  {
    path: "/discord-token/:id",
    name: "Discord Token View",
    component: DiscordTokenView,
    layout: "/admin",
  },
  {
    path: "/discord-token-edit/:id",
    name: "Edit Discord Token",
    component: DiscordTokenCreate,
    layout: "/admin",
  },
  {
    path: "/discord-token-edit",
    name: "Create Discord Token",
    component: DiscordTokenCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/discord-token",
    name: "Discord Token",
    component: DiscordTokenIndex,
    layout: "/admin",
    icon: LibraryBooksIcon,
  },
  // =================================================================== SWAP
  {
    path: "/swap/:id",
    name: "SwapView",
    component: SwapView,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/swap",
    name: "Swap",
    component: SwapIndex,
    layout: "/admin",
    icon: SwapHorizIcon,
  },
  // =================================================================== Staking
  {
    path: "/staking/:id/normal",
    name: "Edit normal staking",
    component: StakingCreateNormal,
    layout: "/admin",
  },
  {
    path: "/staking/:id/soft",
    name: "Edit soft staking",
    component: StakingCreateSoft,
    layout: "/admin",
  },
  {
    path: "/staking-create-normal",
    name: "Create Normal Staking",
    component: StakingCreateNormal,
    layout: "/admin",
  },
  {
    path: "/staking-create-soft",
    name: "Create Soft Staking",
    component: StakingCreateSoft,
    layout: "/admin",
  },
  {
    path: "/staking-create-select",
    name: "Create Staking Select",
    component: StakingCreateSelectType,
    layout: "/admin",
  },
  {
    path: "/staking-fee",
    name: "Config Staking Fee",
    component: StakingFee,
    layout: "/admin",
  },
  {
    path: "/staking-fee-special",
    name: "Config Staking Fee Special",
    component: StakingFeeSpecial,
    layout: "/admin",
  },
  {
    path: "/staking-fee-test",
    name: "Staking Fee Test",
    component: StakingFeeTest,
    layout: "/admin",
  },
  {
    path: "/staking-booster-edit/:poolAddress",
    name: "Edit Booster",
    component: StakingBoosterEdit,
    layout: "/admin",
  },
  {
    path: "/staking-apr-edit/:id",
    name: "Edit APR",
    component: StakingAprEdit,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/staking",
    name: "Staking pools",
    component: StakingIndex,
    layout: "/admin",
    icon: DataSaverOnIcon,
  },
  // =================================================================== Puushdot pool
  {
    isMenu: true,
    path: "/pup404-pool",
    name: "PUP404",
    component: PuushdotPoolIndex,
    layout: "/admin",
    icon: CategoryIcon,
  },
  {
    path: "/pup404/view/:id",
    name: "PUP404",
    component: PuushdotPoolView,
    layout: "/admin",
  },
  {
    path: "/pup404/create",
    name: "Create pup404",
    component: PuushdotPoolCreate,
    layout: "/admin",
  },
  {
    path: "/pup404/edit/:id",
    name: "Edit pup404",
    component: PuushdotPoolCreate,
    layout: "/admin",
  },
  // =================================================================== Activity Puushdot pool
  {
    path: "/pup404/activity/:id",
    name: "Pup404 activity",
    component: PuushdotPoolActivity,
    layout: "/admin",
  },
  // =================================================================== Retro pool
  {
    path: "/pools/view/:id",
    name: "Pools",
    component: RetroPoolView,
    layout: "/admin",
  },
  // =================================================================== NFTS
  {
    path: "/nft/create",
    name: "Create NFT",
    component: NftCreate,
    layout: "/admin",
  },
  {
    path: "/nft/edit/:id",
    name: "Create Category",
    component: NftCreate,
    layout: "/admin",
  },
  // =================================================================== PROFILE
  {
    path: "/profile",
    name: "Profile",
    component: UserProfile,
    layout: "/admin",
  },
  // =================================================================== USERS
  {
    path: "/user/create",
    name: "Create User",
    component: UserCreate,
    layout: "/admin",
  },
  {
    path: "/user/edit/:id",
    name: "Edit user",
    component: UserCreate,
    layout: "/admin",
  },
  {
    path: "/user/:id",
    name: "User",
    component: UserView,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/user",
    name: "User",
    component: UserIndex,
    layout: "/admin",
    icon: Group,
  },

  // =================================================================== Reward
  {
    isMenu: true,
    path: "/reward-tier",
    name: "Reward tier",
    component: RewardTierIndex,
    layout: "/admin",
    icon: Money,
  },
  {
    isMenu: true,
    path: "/reward-summary",
    name: "Reward summary",
    component: RewardSummary,
    layout: "/admin",
    icon: BarChart,
  },

  // ================================================================== Coin
  {
    path: "/distribute-coin/create",
    name: "Distribute Coin",
    component: DistributeCoinCreate,
    layout: "/admin",
  },
  {
    path: "/distribute-coin/edit/:id",
    name: "Distribute Coin",
    component: DistributeCoinCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/distribute-coin",
    name: "Distribute Coin",
    component: DistributeCoinIndex,
    layout: "/admin",
    icon: TollIcon,
  },
  // ================================================================== Payment Coin
  {
    path: "/payment-coin/create",
    name: "Payment Coin",
    component: PaymentCoinCreate,
    layout: "/admin",
  },
  {
    path: "/payment-coin/edit/:id",
    name: "Payment Coin",
    component: PaymentCoinCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/payment-coin",
    name: "Payment Coin",
    component: PaymentCoinIndex,
    layout: "/admin",
    icon: MonetizationOnIcon,
  },

  // ================================================================== Dex Coin
  {
    path: "/dex-coin/create",
    name: "Dex Coin",
    component: DexCoinCreate,
    layout: "/admin",
  },
  {
    path: "/dex-coin/edit/:id",
    name: "Dex Coin",
    component: DexCoinCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/dex-coin",
    name: "Dex Coin",
    component: DexCoinIndex,
    layout: "/admin",
    icon: MonetizationOnIcon,
  },

  // ========================================= Blacklist

  {
    path: "/blacklist/create",
    name: "Blacklist Create",
    component: BlacklistCreate,
    layout: "/admin",
  },
  {
    path: "/blacklist/edit/:id",
    name: "Blacklist Edit",
    component: BlacklistCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/blacklist",
    name: "Blacklist",
    component: BlacklistIndex,
    layout: "/admin",
    icon: NoAccountsIcon,
  },

  // ========================================= Quest

  {
    path: "/quest/create",
    name: "Quest Create",
    component: QuestCreate,
    layout: "/admin",
  },
  {
    path: "/quest/edit/:id",
    name: "Edit Quest",
    component: QuestCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/quest",
    name: "Quest",
    component: QuestIndex,
    layout: "/admin",
    icon: DynamicFormIcon,
  },

  // ========================================= Configs

  {
    path: "/configs/create",
    name: "Configs Create",
    component: ConfigCreate,
    layout: "/admin",
  },
  {
    path: "/configs/edit/:id",
    name: "Config Edit",
    component: ConfigCreate,
    layout: "/admin",
  },
  {
    isMenu: true,
    path: "/configs",
    name: "Configs",
    component: ConfigIndex,
    layout: "/admin",
    icon: SettingsIcon,
  },
];
export default dashRoutes;
